import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SapSocialStarterAngleSourceLocation,
	type SapSocialStarterAngleSourceLocationQuery,
	type SapSocialStarterAngleSourceLocationQueryVariables,
} from './socialStarterAngleSourceLocation.graphql';

/**
 * Best-effort lookup of a social starter draft angle's metadata `source_location` code (which corgi
 * carries into the published petition's `source_location` for staffing). Returns null on any
 * miss/error, or when the draft predates this tagging and has no stamped code — either way the
 * caller falls back to its own default.
 */
export async function fetchSocialStarterAngleSourceLocation({
	token,
	utilityContext,
}: {
	token: string;
	utilityContext: UtilityContext;
}): Promise<string | null> {
	try {
		const { data } = await utilityContext.gql.fetch<
			SapSocialStarterAngleSourceLocationQuery,
			SapSocialStarterAngleSourceLocationQueryVariables
		>({
			query: SapSocialStarterAngleSourceLocation,
			variables: { token },
			rejectOnError: true,
		});

		if (!data.socialStarterPetitionAnglesByToken.success) return null;
		return data.socialStarterPetitionAnglesByToken.metadata?.sourceLocation ?? null;
	} catch {
		return null;
	}
}
